<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
              <i class="fa fa-align-justify"></i> {{$t('TRANSLATOR')}}
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-3">
                  <b-form-fieldset v-bind:label="$t('SEARCHTRANSLATED')">
                    <b-input-group>
                      <b-form-input v-model="pagination.queryTranslated"></b-form-input>
                      <b-input-group-button slot="left">
                        <b-button variant="primary">
                          <icon name="search"></icon>
                        </b-button>
                      </b-input-group-button>
                    </b-input-group>
                  </b-form-fieldset>
                </div>
                <div class="col-sm-3">
                  <b-form-fieldset v-bind:label="$t('SEARCHUNTRANSLATED')">
                    <b-input-group>
                      <b-form-input v-model="pagination.queryUntranslated"></b-form-input>
                      <b-input-group-button slot="left">
                        <b-button variant="primary">
                          <icon name="search"></icon>
                        </b-button>
                      </b-input-group-button>
                    </b-input-group>
                  </b-form-fieldset>
                </div>
                <div class="col-sm-3">
                  <b-form-fieldset v-bind:label="$t('ACTIONS')">
                    <button type="button" v-on:click.prevent="emptyUntranslated" class="btn btn-danger"><icon name="times"></icon> {{$t('EMPTYUNTRANSLATED')}}</button>
                  </b-form-fieldset>
                </div>
              </div>
            </div>
            <div class="card-body" v-if="typeof language.root == 'undefined' || !language.root.length">
              <p class="center">{{$t('NODATAFOUND')}}</p>
            </div>
            <div class="card-body" v-if="typeof language.root != 'undefined' && language.root.length">
              <table class="table table-responsive-sm table-striped">
                <thead>
                  <tr>
                    <th>{{$t('KEY')}}</th>
                    <th>{{$t('PAGEFOUND')}}</th>
                    <th v-for="(lang, langId) in language.languages">{{lang}}</th>
                    <th>{{$t('SAVE')}}</th>
                    <th>{{$t('DELETE')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="word in language.root">
                    <td>{{word.key}}</td>
                    <td>{{word.pageFound}}</td>
                    <td v-for="(lang, langId) in language.languages">
                      <b-form-textarea v-model="word[langId]"></b-form-textarea>
                    </td>
                    <td><b-button size="md" variant="primary" v-on:click.prevent="saveTrans(word)"><icon name="save"></icon> {{$t('SAVE')}}</b-button></td>
                    <td><b-button size="md" variant="danger" v-on:click.prevent="deleteTrans(word)"><icon name="times"></icon> {{$t('DELETE')}}</b-button></td>
                  </tr>
                </tbody>
              </table>
              <nav>
                <b-pagination align="center" :total-rows="parseInt(language.totalCount)" v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>
              </nav>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import TranslatorApi from '@/api/admin/Translator'

export default {
  name: 'Translator',
  data: function()
  {
    return {
      language: {},
      formError: {},
      pagination:
      {
        queryUntranslated: '',
        queryTranslated: '',
        currentPage: 1,
        limit: 20,
        searchTimeout: false
      }
    }
  },
  created: function()
  {
    var me = this;
    me.getLanguage();
  },
  methods:
  {
    ...mapActions([
      'fetchLanguage',
    ]),
    emptyUntranslated()
    {
      var me = this;
      TranslatorApi.emptyUntranslated(function(val)
      {
        if(val.error)
        {
          me.$notify.error(val.notice);
        }
        else
        {
          me.formError = {};
          me.getLanguage();
          me.fetchLanguage(1);
        }
      })
    },
    saveTrans: function(word)
    {
      var me = this;

      TranslatorApi.saveTrans(word, function(val)
      {
        if(val.error)
        {
          me.$notify.error(val.notice);
        }
        else
        {
          me.formError = {};
          me.getLanguage();
          me.fetchLanguage(1);
        }
      })
    },
    deleteTrans: function(word)
    {
      var me = this;

      TranslatorApi.deleteTrans(word, function(val)
      {
        if(val.error)
        {
          me.$notify.error(val.notice);
        }
        else
        {
          me.formError = {};
          me.getLanguage();
          me.fetchLanguage(1);
        }
      })
    },
    getLanguage: function()
    {
      var me = this;
      TranslatorApi.getLanguageTranslations(me.getParams, function(data)
      {
        if(data.error && data.error == true)
        {
          Vue.$notify.error(data.notice);
          return;
        }
        me.language = data;
      });
    }
  },
  watch:
  {
    'pagination.currentPage': function(val)
    {
      var me = this;
      me.getLanguage();
    },
    'pagination.queryUntranslated': function(val)
    {
      var me = this;

      if(val != '') me.pagination.queryTranslated = '';

      if(me.pagination.searchTimeout != false) clearTimeout(me.pagination.searchTimeout);

      me.pagination.searchTimeout = setTimeout(function()
      {
        me.getLanguage();
        me.pagination.searchTimeout = false;
      }, 300);
    },
    'pagination.queryTranslated': function(val)
    {
      var me = this;

      if(val != '') me.pagination.queryUntranslated = '';

      if(me.pagination.searchTimeout != false) clearTimeout(me.pagination.searchTimeout);

      me.pagination.searchTimeout = setTimeout(function()
      {
        me.getLanguage();
        me.pagination.searchTimeout = false;
      }, 300);
    }
  },
  computed:
  {
    getParams: function()
    {
      var me = this;
      var data = Object.assign({}, me.pagination, {});
      data.start = (data.currentPage-1)*data.limit;
      return data;
    }
  }
}
</script>
